import { render, staticRenderFns } from "./WordPress.vue?vue&type=template&id=a69a10ac&scoped=true&"
import script from "./WordPress.vue?vue&type=script&lang=js&"
export * from "./WordPress.vue?vue&type=script&lang=js&"
import style0 from "./WordPress.vue?vue&type=style&index=0&id=a69a10ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69a10ac",
  null
  
)

export default component.exports